import { env } from '@/lib/env';
import { client as apiClient } from '@/api/generated/client.gen';

// Point the generated SDK client at the cross-origin PMS API host.
// `credentials: 'include'` so the guest session cookie (pms_guest_session)
// rides along once magic-link auth lands. No CSRF interceptor yet — the
// booking-engine mutating endpoints don't exist; the admin SPA's
// double-submit interceptor is added in a later slice when checkout /
// cabinet mutations arrive.
export function configureApiClient(): void {
  apiClient.setConfig({
    baseUrl: env.apiOrigin,
    credentials: 'include',
  });
}
